import { useNavigate } from "react-router-dom";
import appIcon from "../assets/appIcon.png";

export default function UserNavbar() {
  const navigate = useNavigate();

  /**
   * Always go to Home page first.
   * If a sectionId is provided, scroll to that section.
   */
  const goToHomeSection = (sectionId?: string) => {
    // Already on Home page
    if (window.location.pathname === "/") {
      if (sectionId) {
        setTimeout(() => {
          document.getElementById(sectionId)?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 50);
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }

      return;
    }

    // Navigate to Home page
    navigate("/");

    // Wait for Home component to render, then scroll
    if (sectionId) {
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 300);
    } else {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 300);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    sessionStorage.removeItem("login_mobile");
    sessionStorage.removeItem("login_phone_prefix");

    // After logout, always go to Home
    navigate("/");

    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 100);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-violet-700 shadow-lg">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">

        {/* Logo */}
        <button
          type="button"
          onClick={() => goToHomeSection()}
          className="flex items-center gap-3 cursor-pointer"
        >
                  <img
            src={appIcon}
            alt="FrendRops"
            className="w-10 h-10 rounded-xl"
          />
          <span className="text-white text-2xl font-bold">
            FrendRops
          </span>
        </button>

        {/* Navigation */}
        <div className="hidden md:flex items-center gap-8 text-white text-lg font-medium">

          {/* HOME */}
          <button
            type="button"
            onClick={() => goToHomeSection()}
            className="hover:text-pink-200 transition"
          >
            Home
          </button>

          {/* PRODUCTS SECTION */}
          <button
            type="button"
            onClick={() => goToHomeSection("products")}
            className="hover:text-pink-200 transition"
          >
            Products
          </button>
          {/* CATEGORIES */}
          <button
            type="button"
            onClick={() => goToHomeSection("categories")}
            className="hover:text-pink-200 transition"
          >
            Categories
          </button>

          {/* FAQ */}
          <button
            type="button"
            onClick={() => goToHomeSection("faq")}
            className="hover:text-pink-200 transition"
          >
            FAQ
          </button>

          {/* CONTACT */}
          <button
            type="button"
            onClick={() => goToHomeSection("contact")}
            className="hover:text-pink-200 transition"
          >
            Contact
          </button>
        </div>
      </div>
    </nav>
  );
}
